function validate_newsletter(event) {
    //Check if it's the right form
    event.preventDefault();
    event.stopPropagation();

    var objForm = $(event.srcElement);
    // Remove previous notices
    objForm.parent().find('div.alert').remove();

    $.post(strAjaxPath + 'subscribe-newsletter.php', objForm.serialize(), function (data) {
        // Show error or success message
        var objDivBox = $('<div class="alert alert-danger mt-2"></div>');
        objDivBox.html('<p>' + data.message + '</p>');

        // Success
        if (data.value == 1) {
            objDivBox.removeClass('alert-danger');
            objDivBox.addClass('alert-success');
        }

        objForm.parent().append(objDivBox);
    }, 'json');
}


(function () {
    'use strict';
    window.addEventListener('load', function () {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                } else {
                    //Call ajax instead submit
                    validate_newsletter(event);
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();